import types from '../mutation-types';
import CarShowroomAPI from '../../api/wgpt/carShowroom';
import { throwErrorMessage } from '../utils/api';

export const state = {
  record: {},
  uiFlags: { isFetching: false, isUpdating: false },
};

export const getters = {
  getShowroom: $state => $state.record,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_WGPT_CAR_SHOWROOM_UI_FLAG, { isFetching: true });
    try {
      const { data } = await CarShowroomAPI.get();
      commit(types.SET_WGPT_CAR_SHOWROOM, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_CAR_SHOWROOM_UI_FLAG, { isFetching: false });
    }
    return null;
  },
  update: async ({ commit }, formData) => {
    commit(types.SET_WGPT_CAR_SHOWROOM_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await CarShowroomAPI.update(formData);
      commit(types.SET_WGPT_CAR_SHOWROOM, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_WGPT_CAR_SHOWROOM_UI_FLAG, { isUpdating: false });
    }
  },
  attachImage: async ({ commit }, { kind, file }) => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await CarShowroomAPI.attachImage(kind, formData);
    commit(types.SET_WGPT_CAR_SHOWROOM, data);
    return data;
  },
  removeImage: async ({ commit }, kind) => {
    const { data } = await CarShowroomAPI.removeImage(kind);
    commit(types.SET_WGPT_CAR_SHOWROOM, data);
    return data;
  },
  // Resolves to { available, reason, min_length, max_length } — the reason names
  // the rule the slug breaks, so callers can explain the rejection.
  checkSlug: async (_ctx, slug) => {
    const { data } = await CarShowroomAPI.slugAvailable(slug);
    return data;
  },
  fetchBackgroundPresets: async () => {
    const { data } = await CarShowroomAPI.backgroundPresets();
    return data.presets;
  },
  applyBackgroundPreset: async ({ commit }, presetId) => {
    const { data } = await CarShowroomAPI.applyBackgroundPreset(presetId);
    commit(types.SET_WGPT_CAR_SHOWROOM, data);
    return data;
  },
};

export const mutations = {
  [types.SET_WGPT_CAR_SHOWROOM_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [types.SET_WGPT_CAR_SHOWROOM]($state, data) {
    $state.record = data;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
